export default {
  loading: '<language>common:loading</language>',
  instructionDrag: '<language>common:instruction-drag</language>',
  instructionDrop: '<language>common:instruction-drop</language>',
  restartButtonCancel: '<language>common:restart-button-cancel</language>',
  restartButtonYes: '<language>common:restart-button-yes</language>',
  restartDescription: '<language>common:restart-description</language>',
  introductionTitle: '<language>introduction-title</language>',
  introductionDescription: '<language>introduction-description</language>',
  virtualLab: '<language>virtual-lab</language>',
  idCard: '<language>id-card</language>',
  usernameLabel: '<language>username-label</language>',
  specialty: '<language>specialty</language>',
  specialtyName: '<language>specialty-name</language>',
  buttonNext: '<language>button-next</language>',
  buttonBack: '<language>button-back</language>',
  buttonPrint: '<language>button-print</language>',
  buttonGotIt: '<language>button-got-it</language>',
  buttonSubmit: '<language>button-submit</language>',
  buttonTryAgain: '<language>button-try-again</language>',
  buttonGoBack: '<language>button-go-back</language>',
  buttonBackToLab: '<language>button-back-to-lab</language>',
  loadingVideo: '<language>loading-video</language>',
  slides: [
    {
      component: 'Slide0',
      imageId: 'bg-slide-0',
      video: {
        id: 'vid-slide-0',
        src: 'assets/videos/vid-slide-0.mp4',
      },
      playAudio: false,
      descriptions: [
        {
          text: '<language>s0-step1</language>',
          voiceOver: 'vo-01-01',
          timeInit: 0,
          timeEnd: 7.3,
        },
        {
          text: '<language>s0-step2</language>',
          voiceOver: 'vo-01-02',
          timeInit: 7.3,
          timeEnd: 20,
        },
        {
          text: '<language>s0-step3</language>',
          voiceOver: 'vo-01-03',
          timeInit: 20,
          timeEnd: 31.18,
        },
      ],
      labels: [
        {
          text: '<language>connector-normal-hemoglobin</language>',
          top: '583px',
          left: '334px',
          timeInit: 8.6,
          timeEnd: 30.24,
        },
        {
          text: '<language>connector-sickle-hemoglobin</language>',
          top: '583px',
          left: '1166px',
          timeInit: 8.6,
          timeEnd: 30.24,
        },
      ],
    },
    {
      component: 'Slide1',
      imageId: 'bg-slide-1',
      video: {
        id: 'vid-slide-1',
        src: 'assets/videos/vid-slide-1.mp4',
      },
      playAudio: true,
      modal: {
        title: '<language>s1-modal-title</language>',
        description: '<language>s1-modal-description</language>',
        image: 's1-modal',
        voiceOver: 'vo-01-modal',
      },
      descriptions: [
        {
          text: '<language>s1-step1</language>',
          voiceOver: 'vo-01-04',
          timeInit: 0,
          timeEnd: 8.2,
        },
        {
          text: '<language>s1-step2-a</language>',
          voiceOver: 'vo-01-05',
          timeInit: 8.2,
          timeEnd: 28,
        },
        {
          text: '<language>s1-step2-b</language>',
          voiceOver: 'vo-01-06',
          timeInit: 28,
          timeEnd: 48.5,
        },
        {
          text: '<language>s1-step3</language>',
          voiceOver: 'vo-01-07',
          timeInit: 48.5,
          timeEnd: 63,
        },
      ],
      labels: [
        {
          text: '<language>connector-cell</language>',
          top: '315px',
          left: '235px',
          timeInit: 4.1,
          timeEnd: 7,
        },
        {
          text: '<language>connector-nucleus</language>',
          top: '184px',
          left: '286px',
          timeInit: 16.7,
          timeEnd: 44.7,
        },
        {
          text: '<language>connector-ribosome</language>',
          top: '139px',
          left: '1433px',
          timeInit: 31.4,
          timeEnd: 44.7,
        },
        {
          text: '<language>connector-dna</language>',
          top: '302px',
          left: '355px',
          timeInit: 55.3,
          timeEnd: 63,
        },
        {
          text: '<language>connector-rna</language>',
          top: '630px',
          left: '355px',
          timeInit: 60.3,
          timeEnd: 63,
        },
      ],
    },
    {
      component: 'Slide2',
      imageId: 'bg-slide-2',
      video: {
        id: 'vid-slide-2',
        src: 'assets/videos/vid-slide-2.mp4',
      },
      playAudio: true,
      modal: {
        title: '<language>s2-modal-title</language>',
        description: '<language>s2-modal-description</language>',
        image: 's2-modal',
        voiceOver: 'vo-02-modal',
      },
      descriptions: [
        {
          text: '<language>s2-step1</language>',
          voiceOver: 'vo-02-01',
          timeInit: 0,
          timeEnd: 15,
        },
        {
          text: '<language>s2-step2</language>',
          voiceOver: 'vo-02-02',
          timeInit: 15,
          timeEnd: 28.5,
        },
        {
          text: '<language>s2-step3</language>',
          voiceOver: 'vo-02-03',
          timeInit: 28.5,
          timeEnd: 44,
        },
        {
          text: '<language>s2-step4</language>',
          voiceOver: 'vo-02-04',
          timeInit: 44,
          timeEnd: 58.7,
        },
        {
          text: '<language>s2-step5</language>',
          voiceOver: 'vo-02-05',
          timeInit: 58.7,
          timeEnd: 69,
        },
      ],
      labels: [
        {
          text: '<language>connector-t-base</language>',
          top: '200px',
          left: '1485px',
          timeInit: 22.3,
          timeEnd: 27,
        },
        {
          text: '<language>connector-mrna-s2</language>',
          top: '263px',
          left: '1298px',
          timeInit: 49,
          timeEnd: 56,
        },
      ],
    },
    {
      component: 'Slide3',
      imageId: 'bg-slide-3',
      video: {
        id: 'vid-slide-3',
        src: 'assets/videos/vid-slide-3.mp4',
      },
      playAudio: true,
      modal: {
        description: '<language>s3-modal-description</language>',
        image: 's3-modal',
        voiceOver: 'vo-03-modal',
      },
      descriptions: [
        {
          text: '<language>s3-step1-a</language>',
          voiceOver: 'vo-03-01',
          timeInit: 0,
          timeEnd: 7,
        },
        {
          text: '<language>s3-step1-b</language>',
          voiceOver: 'vo-03-02',
          timeInit: 7,
          timeEnd: 18,
        },
        {
          text: '<language>s3-step2-a</language>',
          voiceOver: 'vo-03-03',
          timeInit: 18,
          timeEnd: 26.7,
        },
        {
          text: '<language>s3-step2-b</language>',
          voiceOver: 'vo-03-04',
          timeInit: 26.7,
          timeEnd: 57,
        },
        {
          text: '<language>s3-step3</language>',
          voiceOver: 'vo-03-05',
          timeInit: 57,
          timeEnd: 69,
        },
        {
          text: '<language>s3-step4</language>',
          voiceOver: 'vo-03-06',
          timeInit: 69,
          timeEnd: 81,
        },
        {
          text: '<language>s3-step5</language>',
          voiceOver: 'vo-03-07',
          timeInit: 81,
          timeEnd: 96,
        },
        {
          text: '<language>s3-step6</language>',
          voiceOver: 'vo-03-08',
          timeInit: 96,
          timeEnd: 116,
        },
      ],
      labels: [
        {
          text: '<language>connector-ribosome</language>',
          top: '218px',
          left: '660px',
          timeInit: 4.8,
          timeEnd: 16.7,
        },
        {
          text: '<language>connector-mrna</language>',
          top: '318px',
          left: '1422px',
          timeInit: 11.8,
          timeEnd: 16.5,
        },
        {
          text: '<language>connector-codon</language>',
          top: '612px',
          left: '474px',
          timeInit: 30.9,
          timeEnd: 54.8,
        },
        {
          text: '<language>connector-anticodon</language>',
          top: '447px',
          left: '348px',
          timeInit: 35.5,
          timeEnd: 54.8,
        },
        {
          text: '<language>connector-trna</language>',
          top: '430px',
          left: '1160px',
          timeInit: 40,
          timeEnd: 54.8,
        },
        {
          text: '<language>connector-aminoacid</language>',
          top: '132px',
          left: '1261px',
          timeInit: 44.9,
          timeEnd: 54.8,
        },
      ],
    },
    {
      component: 'Slide4',
      imageId: 'bg-slide-4',
      video: {
        id: 'vid-slide-4',
        src: 'assets/videos/vid-slide-4.mp4',
      },
      playAudio: true,
      modal: {
        description: '<language>s4-modal</language>',
        voiceOver: 'vo-04-modal',
      },
      descriptions: [
        {
          text: '<language>s4-step1</language>',
          voiceOver: 'vo-04-01',
          timeInit: 0,
          timeEnd: 9.3,
        },
        {
          text: '<language>s4-step2</language>',
          voiceOver: 'vo-04-02',
          timeInit: 9.3,
          timeEnd: 26,
        },
        {
          text: '<language>s4-step3</language>',
          voiceOver: 'vo-04-03',
          timeInit: 26,
          timeEnd: 39.3,
        },
        {
          text: '<language>s4-step4</language>',
          voiceOver: 'vo-04-04',
          timeInit: 39.3,
          timeEnd: 56,
        },
        {
          text: '<language>s4-step5</language>',
          voiceOver: 'vo-04-05',
          timeInit: 56,
          timeEnd: 76,
        },
      ],
      labels: [
        {
          text: '<language>connector-protein</language>',
          top: '216px',
          left: '1458px',
          timeInit: 14.9,
          timeEnd: 20.6,
        },
        {
          text: '<language>connector-alpha-chain</language>',
          top: '422px',
          left: '1415px',
          timeInit: 16.3,
          timeEnd: 20.6,
        },
        {
          text: '<language>connector-hemoglobin</language>',
          top: '229px',
          left: '309px',
          timeInit: 43.6,
          timeEnd: 52.5,
        },
        {
          text: '<language>connector-normal-hemoglobin</language>',
          top: '582px',
          left: '334px',
          timeInit: 56.4,
          timeEnd: 76,
        },
        {
          text: '<language>connector-sickle-hemoglobin</language>',
          top: '582px',
          left: '1166px',
          timeInit: 56.4,
          timeEnd: 76,
        },
      ],
    },
  ],
};
